import React from "react";
import { DialogTitle, IconButton, Box } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import MediaStats from "./MediaStats";
import { useMediaLibraryModalStyles } from "../utils/styles";

const MediaLibraryHeader = ({ stats, resources, onClose }) => {
	const classes = useMediaLibraryModalStyles();

	return (
		<DialogTitle
			disableTypography
			className={classes.dialogTitle}
			id="media-library-dialog-title"
		>
			<Box display="flex" alignItems="center" id="media-library-stats-box">
				<MediaStats
					stats={stats}
					resources={resources}
					id="media-library-stats"
				/>
			</Box>
			<Box display="flex" alignItems="center" id="media-library-actions-box">
				<IconButton
					className={classes.closeButton}
					onClick={onClose}
					id="media-library-close-btn"
				>
					<Close />
				</IconButton>
			</Box>
		</DialogTitle>
	);
};

export default MediaLibraryHeader;
